export class AdministrationGroupViewModel {
  public groupName: string;

  public members: string[];
}
